/**
 * @fileoverview gRPC-Web generated client stub for country
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.12
// source: protobuf/country/country.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as protobuf_country_country_pb from '../../protobuf/country/country_pb';
import * as protobuf_model_merged_pb from '../../protobuf/model/merged_pb';


export class CountryServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorUpdate = new grpcWeb.MethodDescriptor(
    '/country.CountryService/Update',
    grpcWeb.MethodType.UNARY,
    protobuf_country_country_pb.UpdateCountryRequest,
    protobuf_model_merged_pb.CountryResponse,
    (request: protobuf_country_country_pb.UpdateCountryRequest) => {
      return request.serializeBinary();
    },
    protobuf_model_merged_pb.CountryResponse.deserializeBinary
  );

  update(
    request: protobuf_country_country_pb.UpdateCountryRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_model_merged_pb.CountryResponse>;

  update(
    request: protobuf_country_country_pb.UpdateCountryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.CountryResponse) => void): grpcWeb.ClientReadableStream<protobuf_model_merged_pb.CountryResponse>;

  update(
    request: protobuf_country_country_pb.UpdateCountryRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.CountryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/country.CountryService/Update',
        request,
        metadata || {},
        this.methodDescriptorUpdate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/country.CountryService/Update',
    request,
    metadata || {},
    this.methodDescriptorUpdate);
  }

  methodDescriptorGet = new grpcWeb.MethodDescriptor(
    '/country.CountryService/Get',
    grpcWeb.MethodType.UNARY,
    protobuf_country_country_pb.GetCountriesRequest,
    protobuf_country_country_pb.GetCountriesResponse,
    (request: protobuf_country_country_pb.GetCountriesRequest) => {
      return request.serializeBinary();
    },
    protobuf_country_country_pb.GetCountriesResponse.deserializeBinary
  );

  get(
    request: protobuf_country_country_pb.GetCountriesRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_country_country_pb.GetCountriesResponse>;

  get(
    request: protobuf_country_country_pb.GetCountriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_country_country_pb.GetCountriesResponse) => void): grpcWeb.ClientReadableStream<protobuf_country_country_pb.GetCountriesResponse>;

  get(
    request: protobuf_country_country_pb.GetCountriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_country_country_pb.GetCountriesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/country.CountryService/Get',
        request,
        metadata || {},
        this.methodDescriptorGet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/country.CountryService/Get',
    request,
    metadata || {},
    this.methodDescriptorGet);
  }

  methodDescriptorList = new grpcWeb.MethodDescriptor(
    '/country.CountryService/List',
    grpcWeb.MethodType.UNARY,
    protobuf_country_country_pb.ListCountriesRequest,
    protobuf_country_country_pb.ListCountriesResponse,
    (request: protobuf_country_country_pb.ListCountriesRequest) => {
      return request.serializeBinary();
    },
    protobuf_country_country_pb.ListCountriesResponse.deserializeBinary
  );

  list(
    request: protobuf_country_country_pb.ListCountriesRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_country_country_pb.ListCountriesResponse>;

  list(
    request: protobuf_country_country_pb.ListCountriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_country_country_pb.ListCountriesResponse) => void): grpcWeb.ClientReadableStream<protobuf_country_country_pb.ListCountriesResponse>;

  list(
    request: protobuf_country_country_pb.ListCountriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_country_country_pb.ListCountriesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/country.CountryService/List',
        request,
        metadata || {},
        this.methodDescriptorList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/country.CountryService/List',
    request,
    metadata || {},
    this.methodDescriptorList);
  }

  methodDescriptorExport = new grpcWeb.MethodDescriptor(
    '/country.CountryService/Export',
    grpcWeb.MethodType.UNARY,
    protobuf_country_country_pb.ExportCountriesRequest,
    protobuf_country_country_pb.ExportCountriesResponse,
    (request: protobuf_country_country_pb.ExportCountriesRequest) => {
      return request.serializeBinary();
    },
    protobuf_country_country_pb.ExportCountriesResponse.deserializeBinary
  );

  export(
    request: protobuf_country_country_pb.ExportCountriesRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_country_country_pb.ExportCountriesResponse>;

  export(
    request: protobuf_country_country_pb.ExportCountriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_country_country_pb.ExportCountriesResponse) => void): grpcWeb.ClientReadableStream<protobuf_country_country_pb.ExportCountriesResponse>;

  export(
    request: protobuf_country_country_pb.ExportCountriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_country_country_pb.ExportCountriesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/country.CountryService/Export',
        request,
        metadata || {},
        this.methodDescriptorExport,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/country.CountryService/Export',
    request,
    metadata || {},
    this.methodDescriptorExport);
  }

}

